<div
    *ngIf="!showInternalUserCheck || isInternalUser"
    class="file-upload-box"
    [ngClass]="uploadBoxCSS"
    (dragover)="onDragOver($event)"
    (drop)="onDropSuccess($event)"
    (dragleave)="onDragLeave($event)"
    (click)="onClickEvent($event)"
>
    <div><fa-icon icon="file-arrow-up"></fa-icon></div>
    <div>{{customText}}</div>
</div> 